import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import configureStore from 'store/configureStore';
import App from 'App';
import { BrowserRouter } from 'react-router-dom';

// Get the application-wide store instance, prepopulating with state from the server where available.
const store = configureStore();
store.runSaga();

const container = document.getElementById('root');
if (!container) throw new Error('Failed to find the root element');
const root = createRoot(container);

root.render(
    <Provider store={store}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </Provider>);